import { useMemo } from "react";
import { numberFormat, round } from "shared/util"
import { Avatar, Typography, Stack, Box, LinearProgress } from "@mui/material"
import { PredictionCondition, PredictionData } from 'interface/carenet/prediction'

type PredictionHistoryProps = {
	history: PredictionData
	onSelectedCondition: (condition: PredictionCondition) => void
}
export const PredictionHistory = ({
	history,
	//onSelectedCondition
}: PredictionHistoryProps) => {
	const {
		uploadResult,
		predictionCondition,
		predictionResult
	} = history

	const {
		viewRate,
		viewPerson
	} = useMemo(() => {
		const viewRate = round(predictionResult.predictedViewRate, 2)
		const viewPerson = round((predictionResult.predictedViewRate * uploadResult.postData.recordCount) / 100)
		return { viewRate, viewPerson }
	}, [predictionResult, uploadResult])

	return (
		<Stack direction='row' boxSizing="border-box" spacing={1} paddingX={1} width='100%' alignItems="center">
			<Box padding={1}>
				{predictionCondition.source === 'lv' ? (
					<Avatar sx={{ boxShadow: 3, bgcolor: 'purple', fontSize: 'small' }}>講演</Avatar>
				) : predictionCondition.source === 'mrp' ? (
					<Avatar sx={{ boxShadow: 3, bgcolor: 'green', fontSize: 'small' }}>MRP</Avatar>
				) : (
					<Avatar>?</Avatar>
				)}
			</Box>
			<Stack direction='column' flexGrow={1} paddingRight={2}>
				<Stack direction='row' spacing={0.5} alignItems='baseline'>
					<Typography variant="caption">対象</Typography>
					<Typography variant="h6">{numberFormat(uploadResult.postData.recordCount)}</Typography>
					<Typography variant="caption">人</Typography>
					<Box flexGrow={1}/>
					<Typography variant="caption">×</Typography>
					<Typography variant="h6">{viewRate}</Typography>
					<Typography variant="caption">%</Typography>
					<Typography variant="caption">=</Typography>
					<Typography variant="h6">{viewPerson}</Typography>
					<Typography variant="caption">人</Typography>
				</Stack>
				<LinearProgress
					variant="determinate"
					value={predictionResult.predictedViewRate}
					sx={{
						"& .MuiLinearProgress-bar": {
							 transition: "none"
						}
					}}
				/>
				<Box padding={0.5}>
					<Typography variant="body2">{uploadResult.sharedList.condition}</Typography>
					{predictionCondition.text && <Typography variant="body2">{predictionCondition.text}</Typography>}
				</Box>
			</Stack>
		</Stack>
	)
}
